import { api, tr } from './shared';

export function getWalletSections(lang) {
  const app = api.appHost;
  return [
    {
      id: 'wallet-overview',
      category: tr(lang, 'Wallet и ссылки', 'Wallet & links'),
      navGroup: tr(lang, 'Wallet', 'Wallet'),
      navGroupOrder: 60,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'Apple / Google Wallet — обзор', 'Apple / Google Wallet — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Выдача и обновление карт лояльности в Apple Wallet и Google Wallet. Партнёрам обычно нужны /passes, /pkpass, /google-wallet/save. Хост: app.loyalclub.ru. Идентификаторы — UUID карты шаблона или client_card (короткие номера отклоняются).',
            'Issuing and refreshing loyalty cards in Apple Wallet and Google Wallet. Partners usually need /passes, /pkpass, /google-wallet/save. Host: app.loyalclub.ru. Identifiers are template Card UUID or client_card UUID (short numbers are rejected).',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Ключевые URL', 'Key URLs'),
          items: [
            `GET|POST ${app}/passes/{uuid}`,
            `GET ${app}/pkpass/{client_card_uuid}`,
            `GET ${app}/google-wallet/save/{uuid}`,
          ],
        },
      ],
    },
    {
      id: 'wallet-passes',
      category: tr(lang, 'Wallet и ссылки', 'Wallet & links'),
      navGroup: tr(lang, 'Wallet', 'Wallet'),
      navGroupOrder: 60,
      navSubgroup: tr(lang, 'Выдача', 'Issuing'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: '/passes · /pkpass',
      title: 'GET|POST /passes/{uuid} · GET /pkpass/{client_card_uuid}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            '/passes — поток выдачи по Card.uuid или существующему ClientCard.uuid. Query/body: name, surname, phone, email + UTM/ref. /pkpass — прямой .pkpass для уже выданной client card.',
            '/passes — issue flow by Card.uuid or existing ClientCard.uuid. Query/body: name, surname, phone, email + UTM/ref. /pkpass — raw .pkpass for an already issued client card.',
          ),
        },
        {
          type: 'code',
          title: 'curl passes',
          key: 'wallet-passes',
          value: `curl -X GET "${app}/passes/<CARD_OR_CLIENT_CARD_UUID>?phone=%2B79990001122&name=Ivan"`,
        },
        {
          type: 'code',
          title: 'curl pkpass',
          key: 'wallet-pkpass',
          value: `curl -X GET "${app}/pkpass/<CLIENT_CARD_UUID>" -o card.pkpass`,
        },
      ],
    },
    {
      id: 'wallet-apple-v1',
      category: tr(lang, 'Wallet и ссылки', 'Wallet & links'),
      navGroup: tr(lang, 'Wallet', 'Wallet'),
      navGroupOrder: 60,
      navSubgroup: 'Apple PassKit',
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: '/v1 PassKit webservice',
      title: 'Apple PassKit /v1',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Стандартный webservice для устройств Apple. Authorization: ApplePass auth_{serial}. passTypeId по умолчанию pass.com.loyalclub.cards.',
            'Standard webservice for Apple devices. Authorization: ApplePass auth_{serial}. Default passTypeId pass.com.loyalclub.cards.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Методы', 'Methods'),
          items: [
            'POST /v1/devices/{device_id}/registrations/{pass_type}/{serial}',
            'GET /v1/devices/{device_id}/registrations/{pass_type}?passesUpdatedSince=',
            'GET /v1/passes/{pass_type}/{serial}',
            'DELETE /v1/devices/.../{serial}',
            'POST /v1/log',
          ],
        },
      ],
    },
    {
      id: 'wallet-google',
      category: tr(lang, 'Wallet и ссылки', 'Wallet & links'),
      navGroup: tr(lang, 'Wallet', 'Wallet'),
      navGroupOrder: 60,
      navSubgroup: 'Google Wallet',
      navSubgroupOrder: 30,
      navOrder: 10,
      navLabel: '/google-wallet/*',
      title: 'Google Wallet save · callback · assets',
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Публичные', 'Public'),
          items: [
            `GET ${app}/google-wallet/save/{uuid}`,
            `POST ${app}/google-wallet/callback` + tr(lang, ' (опционально X-Google-Wallet-Callback-Secret)', ' (optional X-Google-Wallet-Callback-Secret)'),
            `GET ${app}/google-wallet/assets/cards/{card_uuid}/logo`,
            `GET ${app}/google-wallet/assets/client-cards/{uuid}/hero[/{stamp_version}]`,
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Кабинет (Bearer)', 'Cabinet (Bearer)'),
          items: [
            'POST /google-wallet/update/{card_number}',
            'POST /google-wallet/broadcast',
          ],
        },
      ],
    },
    {
      id: 'short-links',
      category: tr(lang, 'Wallet и ссылки', 'Wallet & links'),
      navGroup: tr(lang, 'Короткие ссылки', 'Short links'),
      navGroupOrder: 65,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'Short links — /short-links · /s/{code}', 'Short links — /short-links · /s/{code}'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Короткие ссылки для passes, referral и маркетинг-кампаний. Создание требует JWT; resolve и редирект публичны.',
            'Short links for passes, referral and campaigns. Create requires JWT; resolve and redirect are public.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Методы', 'Methods'),
          items: [
            `POST ${app}/short-links  { target_url, code? }  → { code, target_url, short_url }`,
            `GET ${app}/short-links/resolve/{code}  → { target_url }`,
            `GET ${app}/s/{code}  → 307 redirect (+ click_count)`,
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Правила', 'Rules'),
          items: [
            tr(lang, 'target_url проходит is_safe_redirect_url', 'target_url must pass is_safe_redirect_url'),
            tr(lang, 'code 5–32: [A-Za-z0-9_-]', 'code 5–32: [A-Za-z0-9_-]'),
            tr(lang, 'истёкшая ссылка → 410', 'expired link → 410'),
          ],
        },
        {
          type: 'code',
          title: 'curl create',
          key: 'short-create',
          value: `curl -X POST "${app}/short-links" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -H "Content-Type: application/json" \\\n  -d '{"target_url":"${app}/passes/<CARD_UUID>"}'`,
        },
      ],
    },
  ];
}
